import { Injectable } from '@angular/core';
import { RestApiService } from '../services/rest-api.service';
import { Observable } from 'rxjs';


@Injectable()
export class GridService {

  constructor(private restApiService: RestApiService) { }

  public loadGridData(url: string): Observable<any> {
    return this.restApiService.get(url, 'page-center');
  }

  public exportGrid(url: string) {
    return this.restApiService.excel(url, 'export.xls', 'page-center');
  }

  public printGrid(url: string) {
    return this.restApiService.pdf(url, 'print.pdf', 'page-center');
  }
}
